export const iconFontAwesomePhotosImagesImage = (
	<i className="fa-solid fa-image"></i>
);
